import { useMutation, useQuery } from '@tanstack/react-query';
import { httpService } from '../../../Helpers/Fetcher/axios';
import { useNavigate } from 'react-router-dom';
import {
  commonAxiosError,
  commonAxiosSuccess,
  queryClient,
} from '../../../Utils/TanstackQuery/queryClient';
import { b2bApi } from '../../B2BBuyerSeller/apiEndpoints/b2bConstant';
import { exhibitorApi } from '../../Exhibitor/apiEndpoints/constantExhibitor';
import { visitorApi } from '../../Visitor/apiEndpoints/constantVisitor';

export const useSendEmailOTP = (type: {
  type: string | null;
  email: string;
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (data: { email: string; type: string | null }) =>
      httpService.post({
        url: `/api/common/send-email-otp`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Send OTP!`);
      navigate(`/match-otp?email=${type.email}&type=${type.type}`);
    },
    onError: commonAxiosError(),
  });
};
export const useMatchOTP = (type: {
  type: string | null;
  email: string | null;
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (data: {
      email: string | null;
      type: string | null;
      otp: string;
    }) =>
      httpService.post({
        url: '/api/common/match-email-otp',
        data,
      }),
    onSuccess: (data: any) => {
      commonAxiosSuccess(`Successfully Match OTP!`);
      localStorage.setItem('bttf_forget_token', data.token);
      navigate(`/new-password?email=${type.email}&type=${type.type}`);
    },
    onError: commonAxiosError(),
  });
};
export const useSettingNewPass = (type: { type: string | null }) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (data: {
      email: string | null;
      password: string;
      token: string | null;
    }) =>
      httpService.post({
        url: '/api/auth/fair-member/forget/password',
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Set your password!`);
      localStorage.removeItem('bttf_forget_token');
      navigate(
        type.type === 'forget_fair'
          ? '/login'
          : type.type === 'forget_visitor'
          ? '/visitor-login'
          : type.type === 'forget_b2b'
          ? 'b2b-login'
          : ''
      );
    },
    onError: commonAxiosError(),
  });
};

/* get all payment bank api */
export const useGetAllBankAccountList = () => {
  return useQuery({
    queryKey: ['/api/common/payment/accounts'],
    queryFn: () =>
      httpService.get<
        {
          ac_id: number;
          ac_name: string;
          ac_type: string;
          ac_number: string;
          ac_bank_name: string;
          ac_bank_branch: string;
          balance: string;
        }[]
      >({
        url: '/api/common/payment/accounts',
      }),
  });
};

export const useCreateCommonPayment = () => {
  return useMutation({
    mutationFn: (data: FormData) =>
      httpService.post<{ invoice_id: number }, {}>({
        url: '/api/common/payment',
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Done!`);
      const queryKeysToInvalidate = [
        b2bApi.B2B_INVOICE_LIST,
        visitorApi.GET_VISITOR_INVOICE,
        exhibitorApi.GET_EXHIBITOR_INVOICE_LIST,
      ];
      queryKeysToInvalidate?.forEach((key) => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: commonAxiosError(),
  });
};
